import { Injectable } from '@angular/core';

@Injectable()
export class SearchTitlesService {

}


// WEBPACK FOOTER //
// ./src/app/catalogue/search-titles/search-titles.service.ts